import { EmployeeProperties } from "../../types/employee.type";
import { Link } from "react-router-dom";
import { Card, Tooltip, Table, Input, Col, Select } from "antd";
import { ExclamationCircleOutlined, SearchOutlined } from "@ant-design/icons";
import NotSet from "../../components/NotSet";
import { formatUcWords } from "../../helpers/format";
import { ColumnType } from "antd/lib/table";
import CustomPagination from "../../components/CustomPagination";
import Filter from "../../components/Filter";
import { EEmployeeRoleStatus } from "../../types/employeeRole.type";
import FilterOffice from "../../components/form/FilterOffice";

interface IProps {
	data: EmployeeProperties[];
	setQuery: any;
	query: any;
	search?: string;
	setSearch: any;
	isLoading: boolean;
	pagination?: any;
	changePage?: any;
}
const ALL_STATUS = [
	EEmployeeRoleStatus.OPEN,
	EEmployeeRoleStatus.PUBLISH,
	EEmployeeRoleStatus.UNPUBLISH,
	EEmployeeRoleStatus.INACTIVE,
];
export default function Agent(props: IProps) {
	const { setQuery, query, data, search, setSearch, isLoading, pagination, changePage } = props;

	const COLUMNS = [
		{
			title: "Agent ID",
			dataIndex: "employeeCode",
			key: "employeeCode",
			width: "150px",
			render: (employeeCode: string, record: EmployeeProperties) => {
				let to = `/agent/${record.userId}`;

				return <Link to={to}>{employeeCode.toUpperCase()}</Link>;
			},
		},
		{
			title: (
				<>
					{"AGENT NAME"}
					<Tooltip title="Nickname">
						<ExclamationCircleOutlined style={{ marginLeft: 6, cursor: "pointer" }} />
					</Tooltip>
				</>
			),
			dataIndex: ["user", "nickName"],
			key: "nickName",
			render: (nickname: string) => <>{nickname ? nickname.toUpperCase() : <NotSet />}</>,
		},
		{
			title: "OFFICE NAME",
			dataIndex: ["office", "officeName"],
			key: "officeName",
			render: (officeName: string) => {
				return <>{officeName}</>;
			},
		},
		{
			title: "STATUS",
			dataIndex: "status",
			key: "status",
			width: 200,
			render: (status: string) => {
				return formatUcWords(status);
			},
		},
	].filter(Boolean) as ColumnType<EmployeeProperties>[];

	const _handleChangeOffice = (officeId: string) => {
		setQuery({
			...query,
			filterOfficeId: officeId,
		});
	};

	const _handleFilterStatus = (filterRoleStatus: string) => {
		setQuery({
			...query,
			filterRoleStatus,
		});
	};

	return (
		<>
			<Card
				bordered={false}
				size="small"
			>
				<Filter>
					<Filter.Medium>
						<Input
							value={search}
							className="outer-shadow"
							placeholder={"Search by Name, " + formatUcWords("Agent") + " ID, Email or Phone"}
							title={"Search by Name, " + formatUcWords("Agent") + " ID, Email or Phone"}
							suffix={<SearchOutlined />}
							allowClear
							onChange={(e) => setSearch(e.target.value)}
						/>
					</Filter.Medium>
					<Col span={5}>
						<Select
							virtual={true}
							onChange={_handleFilterStatus}
							className="outer-shadow"
							placeholder="Published"
							value={query.filterRoleStatus}
							options={[
								{
									label: "All Status",
									value: Object.values(ALL_STATUS).join(","),
								},
								{
									value: EEmployeeRoleStatus.OPEN,
									label: "Open",
								},

								{
									value: EEmployeeRoleStatus.PUBLISH,
									label: "Active",
								},
								{
									value: EEmployeeRoleStatus.UNPUBLISH,
									label: "Unpublish",
								},
								{
									value: EEmployeeRoleStatus.INACTIVE,
									label: "Inactive",
								},
							]}
						/>
					</Col>
					<Col span={7}>
						<FilterOffice
							value={query.filterOfficeId}
							onChange={_handleChangeOffice}
							showOfficeCode={true}
						/>
					</Col>
				</Filter>
				<Table
					loading={isLoading}
					columns={COLUMNS}
					dataSource={data}
					pagination={false}
					rowKey="userId"
					scroll={{ x: "100%" }}
				/>
				<CustomPagination
					current={pagination.page}
					total={pagination.totalData}
					defaultPageSize={pagination.perPage}
					pageSize={pagination.perPage}
					onChange={changePage}
				/>
			</Card>
		</>
	);
}
